import { SearchMode, useSearch } from "~/core/composables/useSearch";
import LxcError from "~/core/models/LxcError.class";
import {
  Filters,
  type FiltersSelection,
  FiltersType,
  OPERATOR_RSQL_ILIKE,
} from "~/core/models/filters";
import filtersUtils from "~/core/utils/filters.utils";
import type { BusinessUnit } from "~/modules/businessUnit/models/BusinessUnit.interface";
import businessUnitService from "~/modules/businessUnit/services/businessUnit.service";

export function useBusinessUnit(
  searchMode: SearchMode = SearchMode.URL_SEARCH,
) {
  const appliedFilters: FiltersSelection = new Map([
    [
      Filters.BUSINESS_UNIT_NAME,
      {
        key: "name",
        operator: OPERATOR_RSQL_ILIKE,
        value: "",
        valueFormatter: filtersUtils.formatRSQLValue,
      },
    ],
  ]);

  const { searchParams, filters, setFilter, search, onSearch } = useSearch(
    FiltersType.RSQL,
    appliedFilters,
    searchMode,
  );

  const results: Ref<BusinessUnit[] | undefined> = ref();
  const isLoading: Ref<boolean> = ref(false);
  const error: Ref<LxcError | undefined> = ref();

  async function fetchData() {
    isLoading.value = true;
    const response = await businessUnitService.getBusinessUnits(
      searchParams.value,
    );
    if (LxcError.check(response)) {
      error.value = response;
    } else {
      results.value = response;
    }
    isLoading.value = false;
  }

  return {
    isLoading,
    results,
    error,
    filters,
    fetchData,
    setFilter,
    search,
    onSearch,
  };
}
